// extracted by mini-css-extract-plugin
module.exports = {"card":"MainCard-module_card_3nvfD","cardHeader":"MainCard-module_cardHeader_375Wa","label":"MainCard-module_label_32KNE"};